import React from 'react';

const Checkout = () => {
    return (
        <div className='flex items-center justify-center' style={{ minHeight: '400px' }}>
            <h1 className='text-green-500 text-3xl'>Thank You For Choosing!!</h1>
        </div>
    );
};

export default Checkout;